<mat-list-item
  class="mat-list-item"
  [ngClass]="{ 'mat-list-item-light': hidden }"
>
  @if (auth.authenticated) {
    <button
      matListItemAvatar
      mat-icon-button
      igoStopPropagation
      [matTooltip]="
        auth.authenticated
          ? ('igo.context.contextManager.favorite' | translate)
          : ''
      "
      matTooltipShowDelay="500"
      [color]="default() ? 'primary' : 'default'"
      (click)="favoriteClick(context())"
    >
      @if (!context().iconImage) {
        <mat-icon>{{
          context().icon
            ? context().icon
            : context().scope === 'public'
              ? 'public'
              : 'star'
        }}</mat-icon>
      } @else {
        <img
          [src]="context().iconImage"
          alt="Icône pour le favori de contexte"
        />
      }
    </button>
  } @else if (showFavorite()) {
    <button
      matListItemAvatar
      mat-icon-button
      igoStopPropagation
      [matTooltip]="'igo.context.contextManager.favorite' | translate"
      matTooltipShowDelay="500"
      [color]="default() ? 'primary' : 'default'"
      (click)="favoriteClick(context())"
    >
      <mat-icon>star</mat-icon>
    </button>
  }

  <span matListItemTitle>{{ context().title }}</span>

  @if (auth.authenticated) {
    <div
      matListItemMeta
      igoStopPropagation
      class="igo-actions-container"
      [class.--not-desktop]="!isDesktop()"
      [class.--selected]="selected()"
    >
      @if (
        collapsed &&
        selected() &&
        (context().permission === 'write' || context().imported)
      ) {
        <button
          class="save-button"
          mat-icon-button
          [matTooltip]="'igo.context.contextManager.save' | translate"
          matTooltipShowDelay="500"
          [color]="color"
          (click)="save.emit(context())"
        >
          <mat-icon>save</mat-icon>
        </button>
      }

      <button
        class="actions-button"
        mat-icon-button
        [color]="color"
        [matMenuTriggerFor]="itemActionsMenu"
        #itemActionsMenuTrigger="matMenuTrigger"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #itemActionsMenu="matMenu">
        @if (!context().imported) {
          @if (canShare) {
            <button
              mat-menu-item
              [matTooltip]="
                'igo.context.contextManager.managePermissions' | translate
              "
              matTooltipShowDelay="500"
              (click)="managePermissions.emit(context())"
            >
              <mat-icon>manage_accounts</mat-icon
              ><span>{{
                'igo.context.contextManager.managePermissions' | translate
              }}</span>
            </button>
          }

          <button
            class="clone-button"
            mat-menu-item
            [matTooltip]="'igo.context.contextManager.clone' | translate"
            matTooltipShowDelay="500"
            (click)="clone.emit(context())"
          >
            <mat-icon>content_copy</mat-icon>
            <span>{{ 'igo.context.contextManager.clone' | translate }}</span>
          </button>

          @if (context().permission === 'write') {
            <button
              class="edit-button"
              mat-menu-item
              [matTooltip]="'igo.context.contextManager.edit' | translate"
              matTooltipShowDelay="500"
              (click)="edit.emit(context())"
            >
              <mat-icon>edit</mat-icon>
              <span>{{ 'igo.context.contextManager.edit' | translate }}</span>
            </button>
          }

          @if (!context().hidden) {
            <button
              class="hide-button"
              mat-menu-item
              [matTooltip]="'igo.context.contextManager.hide' | translate"
              matTooltipShowDelay="500"
              (click)="hide.emit(context())"
            >
              <mat-icon>visibility</mat-icon>
              <span>{{ 'igo.context.contextManager.hide' | translate }}</span>
            </button>
          }

          @if (context().hidden) {
            <button
              class="hide-button"
              mat-menu-item
              [matTooltip]="'igo.context.contextManager.show' | translate"
              matTooltipShowDelay="500"
              (click)="show.emit(context())"
            >
              <mat-icon>visibility_off</mat-icon>
              <span>{{ 'igo.context.contextManager.show' | translate }}</span>
            </button>
          }

          <button
            mat-menu-item
            class="share-button"
            [matTooltip]="'igo.context.contextManager.share' | translate"
            matTooltipShowDelay="500"
            (click)="share.emit(context())"
          >
            <mat-icon>share</mat-icon>
            <span>{{ 'igo.context.contextManager.share' | translate }}</span>
          </button>
        }

        @if (context().permission === 'write' || context().imported) {
          <button
            class="delete-button"
            mat-menu-item
            color="warn"
            [matTooltip]="'igo.context.contextManager.delete' | translate"
            matTooltipShowDelay="500"
            (click)="delete.emit(context())"
          >
            <mat-icon>delete</mat-icon>
            <span>{{ 'igo.context.contextManager.delete' | translate }}</span>
          </button>
        }
      </mat-menu>
    </div>
  }
</mat-list-item>
